/*
* config.js
* Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
* All rights reserved.
*/
let config = {};

export const loadConfig = async () => {
  try {
    const response = await fetch("/Config.json");
    config = await response.json();
    globalThis._APP_CONFIG = config;
  } catch (error) {
    console.error("Failed to load config.json:", error);
  }
};

export const getConfig = () => config;
